<template>
  
</template>

<script>
import storeGetDataMixin from '@/mixins/storeGetDataMixin.vue'
const slgaColumns = ['SITE ID', 'TIMESTAMP', 'TRANSACTION ID', 'GTIN', 'PRODUCT DISPLAY NAME', 'TRANSACTION CODE', 'TRANSACTION TYPE', 'QTY', 'UNIT COST', 'UNIT PRICE', 'SYSTEM', 'NOTE',]
const slgaRow = {'SITE ID' : 'SKR1277-01', 'TIMESTAMP' : '', 'TRANSACTION ID' : '', 'GTIN' : '', 'PRODUCT DISPLAY NAME' : '', 'TRANSACTION CODE' : '', 'TRANSACTION TYPE' : '', 'QTY' : '', 'UNIT COST' : '', 'UNIT PRICE' : 0, 'SYSTEM' : 'CRE', 'NOTE' : '',}
export default {
  props:['storeName'],
  mixins : [storeGetDataMixin],
  computed:{
    transactionStore(){
      return this.page.$refs[this.storeName]
    },
    store(){
      return this.transactionStore
    }
  },
  data () { return {
    timestamps:{
        dateKey:'month',
        from: undefined,
        to: undefined,
      },
      data:{
        CCS: {
          isLoading: false, 
          inventory:undefined,
          openingInventory:[],
          purchases:[],
          sales:[],
          closingInventory:[],
        },
      },
  }
  },
  mounted() {
    console.log('SLGA Transaction Store mounted')
    // temporary
    this.loadData();
  },
  computed:{

  },
  methods: {
    loadData: function(){
      if (!document.hasFocus())
        return;
        
      //Strip timezone from ts 
      //Not sure if this is needed since I'm get the ts from the server
      let  from = moment(this.timestamps.from).startOf(this.timestamps.dataKey).format("YYYY-MM-DD HH:mm:ss");
      let  to = moment(this.timestamps.to).endOf(this.timestamps.dataKey).format("YYYY-MM-DD HH:mm:ss");
      //Skip if from and to are the same
      // if(from === to){
      //   console.log('skipping')
      //   return
      // }

      console.log('from to', from, to);

      //Haven't switched over to SOG instead of CCS
      const location = 'CCS';
      //Not sure if I'm using the timestamps yet
      const data = { location, date:'2021-11-01', from: this.timestamps.from, to: this.timestamps.to }
      const openingCB = (location, response) => {
        console.log('SLGA Callback - OpeningCB', response)
        let openingInventory = response.data.map(r=>{
          const result = JSON.parse(JSON.stringify(slgaRow));
          // TODO hardcoded date
          result.TIMESTAMP = moment(data.date).startOf('month').format('YYYY-MM-DD 00:00:00')
          result.GTIN = this.skuExceptions(r.Vendor_Part_Num)
          result['PRODUCT DISPLAY NAME'] = this.displayName(r)
          result['TRANSACTION CODE'] = "500001"
          result['TRANSACTION TYPE'] = 'Opening Inventory'
          result.QTY = r.Start_Stock
          result['UNIT COST'] = r.Cost 
          return result;
        })
        console.log('DEBUG set', this.data[location]);
        // this.data[location].openingInventory = openingInventory;
        this.$set(this.data[location], 'openingInventory', openingInventory)
      }
      const closingCB = (location, response) => {
        console.log('SLGA Callback - ClosingCB', response)
        let closingInventory = response.data.map(r=>{
          const result = JSON.parse(JSON.stringify(slgaRow));
          // TODO hardcoded date
          result.TIMESTAMP = moment(data.date).endOf('month').format('YYYY-MM-DD 23:59:59')
          result.GTIN = this.skuExceptions(r.Vendor_Part_Num)
          result['PRODUCT DISPLAY NAME'] = this.displayName(r)
          result['TRANSACTION CODE'] = "500002"
          result['TRANSACTION TYPE'] = 'Closing Inventory'
          result.QTY = r.Start_Stock
          result['UNIT COST'] = r.Cost 
          return result;
        })
        // this.data[location].closingInventory = closingInventory;
        // console.log(obj);
        this.$set(this.data[location], 'closingInventory', closingInventory)
      }

      this._postData('/Reports/CCS/Inventory', 'inventory', location, data, openingCB, true)

      this._postData('/Reports/CCS/Inventory', 'inventory', location, {...data, date:moment(data.date).add(1, 'month').startOf('month')}, closingCB, true)
      this._postData('/Reports/CCS/Purchases', 'purchasesRaw', location, data, (location, response)=>{
        
        let purchases = response.data.map(r=>{
          const result = JSON.parse(JSON.stringify(slgaRow));
          // TODO hardcoded date
          result.TIMESTAMP = r.DateTime
          result.GTIN = this.skuExceptions(r.Vendor_Part_Num)
          result['PRODUCT DISPLAY NAME'] = this.displayName(r)
          result['TRANSACTION ID'] = r.id.toUpperCase()
          result['TRANSACTION CODE'] = "100001"
          result['TRANSACTION TYPE'] = 'Additions - Purchased'
          result.QTY = r.Quantity
          result['UNIT COST'] = r.CostPer 
          return result;
        })
        console.log('DEBUG purchases', response.data);
        // this.data[location].openingInventory = openingInventory;
        this.$set(this.data[location], 'purchases', purchases)
      }, true);
      this._postData('/Reports/CCS/Sales', 'salesRaw', location, data, (location, response)=>{
        
        let sales = response.data.map(r=>{
          const result = JSON.parse(JSON.stringify(slgaRow));
          // TODO hardcoded date
          result.TIMESTAMP = r.DateTime
          result.GTIN = this.skuExceptions(r.Vendor_Part_Num)
          result['PRODUCT DISPLAY NAME'] = this.displayName(r)
          result['TRANSACTION ID'] = r.ObjectID.toUpperCase()
          result['TRANSACTION CODE'] = "200001"
          result['TRANSACTION TYPE'] = 'Reductions - Retail Sale'
          result.QTY = r.Quantity
          result['UNIT COST'] = r.CostPer //* r.Quantity
          result['UNIT PRICE'] = r.PricePer //* r.Quantity

          return result;
        })
        console.log('DEBUG sales', response.data);
        this.$set(this.data[location], 'sales', sales)
      }, true);
      
    },
    displayName(r){
      // let result = `${r.ItemName} ${r.ItemName_Extra} - Equiv: ${r.Unit_Size} ${r.Unit_Type} - Dep: ${r.Dept_ID}`
      let result = `${r.ItemName} ${r.ItemName_Extra} - Dep: ${r.Dept_ID}`
      return result.substring(0, 255);
    },
    skuExceptions(sku){
      sku = sku.padStart(14, '0')
      let exceptions = {
        '00689285001720' : '20689285001724', //D9 GPS 3.5
        '00689285001362' : '20689285001366', //D9 Space Cake 3.5
        '00689285002000' : '20689285002004', //D9 Black Cherry Punch Flower 3.5
        '00689285001997' : '20689285001991', //D9 Black Cherry Punch Pre-roll
        '00689285000136' : '20689285000130', //D9 White Out 3.5
        '00689285001409' : '20689285001403', //D9 Apple Fritter 3.5
        '00689285001539' : '20689285001533', //D9 Sinaloa Gold 3.5
        '006892850020481' : '0068831800104', //Homestead Bangtail 28g
      }
      function objectFlip(obj) {
        const ret = {};
        Object.keys(obj).forEach(key => ret[obj[key]] = key);
        return ret;
      }
      // Flip the object keys and values
      exceptions = objectFlip(exceptions)
      
      return (exceptions[sku] ? exceptions[sku] : sku).substring(0, 14); 
    },
  }
}
</script>